export const GLOBAL_CONTENT = {
  eyebrow: { es: "Alcance global", en: "Global reach", pt: "Alcance global" },
  title: {
    es: "Importamos desde los principales hubs del mundo",
    en: "We import from the world's major trade hubs",
    pt: "Importamos dos principais hubs do mundo",
  },
  sub: {
    es: "Rutas activas de importación internacional hacia Venezuela y Estados Unidos.",
    en: "Active international import routes into Venezuela and the United States.",
    pt: "Rotas ativas de importação internacional para a Venezuela e os Estados Unidos.",
  },
  origins: { es: "Orígenes", en: "Origins", pt: "Origens" },
  destinations: { es: "Destinos", en: "Destinations", pt: "Destinos" },
};

export const MAP_ORIGINS = [
  { id: "china", label: "China", coords: [121.47, 31.23], anchor: "middle", dy: -12 },
  { id: "panama", label: { es: "Panamá", en: "Panama", pt: "Panamá" }, coords: [-79.52, 8.98], anchor: "end", dy: -14 },
  { id: "colombia", label: "Colombia", coords: [-74.07, 4.71], anchor: "middle", dy: 22 },
  { id: "usa", label: { es: "EE.UU.", en: "USA", pt: "EUA" }, coords: [-95.71, 37.09], anchor: "middle", dy: -12 },
];

export const MAP_DESTINATIONS = [
  { id: "caracas", label: "Caracas", coords: [-66.9, 10.48], anchor: "start", dy: -14 },
  { id: "newyork", label: "New York", coords: [-73.89, 41.21], anchor: "middle", dy: 18 },
];

export const MAP_ROUTES = [
  { id: "china-ve", from: [121.47, 31.23], to: [-66.9, 10.48] },
  { id: "china-us", from: [121.47, 31.23], to: [-73.89, 41.21] },
  { id: "panama-ve", from: [-79.52, 8.98], to: [-66.9, 10.48] },
  { id: "colombia-ve", from: [-74.07, 4.71], to: [-66.9, 10.48] },
  { id: "us-ve", from: [-73.89, 41.21], to: [-66.9, 10.48] },
];
